(function () {
    "use strict";

    function InterviewOpenDayForm(scope, hUser) {
        var self = this;
        var formName = "interview-open-day-form";
        var _protected = BaseForm.call(self, formName, scope);

        self.data = {};
        self.formSubmitted = false;

        self.load = function (formData) {
            self.loading = true;
            scope.$digest();

            InterviewV2API.getBrandOpenDays(formData.brandId, formData.jobId, new Date())
                .then(function (openDays) {

                    if (openDays.interview_sets || openDays.interview_sets.length) {
                        self.openDaysList = openDays.interview_sets;
                    }
                    else {
                        self.openDaysList = [];
                    }

                    if (formData.openDayId) {
                        const matchingOpenDay = self.openDaysList.find(openDay => openDay.id === formData.openDayId);
                        if (matchingOpenDay) {
                            self.data.selectedOpenDayId = formData.openDayId;
                            matchingOpenDay.selected = true;
                        }
                    }

                    self.loading = false;
                    scope.$digest();
                }, function (error) {
                    console.error(error);
                    self.loading = false;
                    scope.$digest();
                });
        };

        self.save = function () {
            self.formSubmitted = true;
            var deferred = $q.defer();

            if (self.data.selectedOpenDayId) {
                deferred.resolve(self.data);
            }
            else {
                deferred.reject();
            }

            return deferred.promise;
        };

        self.selectOpenDay = function (openDay) {
            if (self.data.selectedOpenDayId !== openDay.id) {

                for (var d in self.openDaysList) {
                    delete self.openDaysList[d].selected;
                }

                self.data.selectedOpenDayId = openDay.id;
                openDay.selected = true;
            }
        };
    }

    angular
        .module('harriApp.interviewV2')
        .service('InterviewOpenDayForm', [
            'hUser',
            function (hUser) {

                return function (scope) {
                    return new InterviewOpenDayForm(scope, hUser);
                }
            }]);
})();
